import { render, staticRenderFns } from "./EstoqueForm.vue?vue&type=template&id=00daddd1&scoped=true&"
import script from "./EstoqueForm.vue?vue&type=script&lang=js&"
export * from "./EstoqueForm.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueForm.vue?vue&type=style&index=0&id=00daddd1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00daddd1",
  null
  
)

export default component.exports